module.exports = __webpack_public_path__ + "static/media/AVALANCHE.05c253e5.svg";